import * as flatpickr from 'flatpickr'; // Import flatpickr itself to register locales

export async function getFlatpickrLocale(lang) {
    switch (lang) {
        case 'zh-CN':
            // Use the official flatpickr Simplified Chinese locale
            const { Mandarin: OfficialSimplifiedChinese } = await import('flatpickr/dist/l10n/zh.js');
            return OfficialSimplifiedChinese;
        case 'zh-TW':
            const { MandarinTraditional } = await import('flatpickr/dist/l10n/zh-tw.js');
            return MandarinTraditional;
        default:
            // For 'en' and any other language, flatpickr's default is English.
            // flatpickr automatically uses English if no locale is provided or if the locale is undefined.
            // We explicitly import default.js for clarity, though it's often minimal.
            const { default: DefaultLocale } = await import('flatpickr/dist/l10n/default.js');
            return DefaultLocale;
    }
}
